import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Handles hash scrolling when navigating to home page with #anchor.
export default function HashScroller() {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    // small delay to allow rendered content
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "auto", block: "start" });
    }, 30);
    return () => clearTimeout(t);
  }, [location]);
  return null;
}
